<main>
  <section class="banner">
    <h3 data-test-id="searchBarBannerHeader">{{ config.header }}</h3>
    @if (config?.subHeader) {
      <span data-test-id="searchBarBannerSubHeader">{{ subHeaderText }}</span>
    } @else {
      Please update the filters below to view covered providers.
    }
  </section>

  @if (config?.searchBarHeaderText) {
    <section class="search__header__textbox">
      <p
        class="t-data"
        data-test-id="searchBarBannerHeaderText"
        [innerHTML]="config?.searchBarHeaderText"
      ></p>
    </section>
  }

  <section class="search__header__filters">
    <div class="form-control__wrapper">
      <div class="search__header__distance">
        <div
          class="form-control form-control--dropdown search__distance--dropdown"
        >
          <select (change)="onWithinDistanceChange($event.target.value)">
            @for (
              distance of searchConfig.locationConfig.within;
              track distance;
              let i = $index
            ) {
              <option
                [attr.data-test-id]="'searchBarOption_' + i"
                [selected]="distance === selectedDistance"
              >
                Within {{ distance }} miles of
              </option>
            }
          </select>
          <div class="u-flex u-alignCenter u-justifyEnd u-fillRemaining">
            <icon
              data-test-id="searchBarExpandIcon"
              [name]="'carat_down'"
            ></icon>
          </div>
        </div>

        <div class="u-relative">
          <input
            class="form-control search__distance--input"
            [value]="initialZipcode"
            data-test-id="searchBarInput"
            (keyup.enter)="onSearchAreaInputEnter($event.target.value)"
          />
          <div class="form-control__hint">
            <!--<span-->
            <!--class="t-caption t-link"-->
            <!--(click)="onUseMyCurrentLocationClick()">-->
            <!--Use My Current Location-->
            <!--</span>-->
          </div>
        </div>

        <div class="search__header--providerSearchBar">
          <div class="form-control__icon">
            <i class="icon icon--medium" data-test-id="searchBarSearchIcon"
              >search</i
            >
          </div>
          <input
            class="form-control"
            [placeholder]="providerSearchBarText || 'Provider Last Name'"
            data-test-id="searchBarLastNameInput"
            (keyup.enter)="onSearchProviderName($event.target.value)"
          />
        </div>
      </div>
    </div>
  </section>
</main>
